<template>
  <Layout></Layout>
</template>

<script>
import Layout from 'vue-common-laboratory/src/layout/Index.vue' //导航
export default {
  components: {
    Layout
  }
}
</script>


// WEBPACK FOOTER //
// src/layout/Index.vue